import { Expose } from 'class-transformer';
import { UserRole } from './role';

export class User {
    id?: number;
    username: string;
    password: string;
    repeatedPassword: string;
    description: string;
    connected: boolean;
    @Expose({ name: 'last_login_time' })
    lastLoginTime?: number;
    @Expose({ name: 'last_logout_time' })
    lastLogoutTime?: number;
    @Expose({ name: 'show_only_on_course' })
    showOnlyOnCourse: boolean;
    roles: UserRole[];
    groups: number[];
    firstName?: string;
    lastName?: string;
    email?: string;

    hasAnyRoles(...rolesToCheck: UserRole[]): boolean {
        return rolesToCheck.some(r => this.roles.includes(r));
    }

}
